module.exports = __webpack_public_path__ + "img/battery-5.986c816c.svg";